import { calcBrightness } from './calc-brightness'

export const isDarkHex = (hexColor?: string, coeff?: number) => {
	try {
		return calcBrightness(hexColor) < (coeff || 0.5) ? true : false
	} catch (e) {
		return true
	}
}
